import { Navigate, Route, Routes } from 'react-router-dom';
import TennisCourtPage from './TennisCourtPage';

/**
 * Facilities configuration area. Currently hosts the tennis court booking UI;
 * additional amenity tools can be nested here later.
 */
const FacilitiesPage = () => (
  <Routes>
    <Route index element={<Navigate to="tennis" replace />} />
    <Route path="tennis" element={<TennisCourtPage />} />
    <Route path="*" element={<Navigate to="tennis" replace />} />
  </Routes>
);

export default FacilitiesPage;
